export default __webpack_public_path__ + "static/media/home.fe3b5b46.png";